module.exports = __webpack_public_path__ + "img/qepcopyqep.6de3148d.png";